// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-hover:hover {
  background-color: rgb(134, 134, 134, 0.1);
  border-radius: 2px;
  transition: 0.2s;
}
.dropDownMenu.active {
  transition: 0.5s;
  height: 100%;
  display: block;
}
.dropDownMenu.hidden {
  height: 0;
}

.onclicklist {
  background-color: #303030;
  border-radius: 5px;
  color: #fff !important;
}
.onclicklist:hover {
  background-color: #303030;
  border-radius: 5px;
}
.popup_signout.activeSignOut {
  background-color: rgba(68, 68, 68, 0.8);
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  aspect-ratio: 2/1;
}
.popup_signout.hiddenSignOut {
  display: none;
  height: 0;
}

.scroll-stable-center {
  scrollbar-gutter: stable both-edges;
}

.toggle-scroll {
  overflow-y: hidden;
}
.toggle-scroll:hover {
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/dashboard/sidebar/TheSidebar.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".item-hover:hover {\n  background-color: rgb(134, 134, 134, 0.1);\n  border-radius: 2px;\n  transition: 0.2s;\n}\n.dropDownMenu.active {\n  transition: 0.5s;\n  height: 100%;\n  display: block;\n}\n.dropDownMenu.hidden {\n  height: 0;\n}\n\n.onclicklist {\n  background-color: #303030;\n  border-radius: 5px;\n  color: #fff !important;\n}\n.onclicklist:hover {\n  background-color: #303030;\n  border-radius: 5px;\n}\n.popup_signout.activeSignOut {\n  background-color: rgba(68, 68, 68, 0.8);\n  display: block;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  aspect-ratio: 2/1;\n}\n.popup_signout.hiddenSignOut {\n  display: none;\n  height: 0;\n}\n\n.scroll-stable-center {\n  scrollbar-gutter: stable both-edges;\n}\n\n.toggle-scroll {\n  overflow-y: hidden;\n}\n.toggle-scroll:hover {\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
